import { GoogleApiWrapper } from "google-maps-react";
import { useEffect, useRef } from "react";
import { useEventStore } from "stores/event/useEventStore";

const API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const CustomMapControl = ({ searchType }) => {
  const inputRef = useRef(null);
  
  const inputValue = useEventStore((state) => state.inputValue);

  const setZoom = useEventStore((action) => action.setZoom);
  const setInputValue = useEventStore((action) => action.setInputValue);
  const setSelectedPlace = useEventStore((s) => s.setSelectedPlace);
  const setPlaceAutocomplete = useEventStore((action) => action.setPlaceAutocomplete);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    const raw = Array.isArray(searchType) ? searchType : [searchType];
    const searchTypes = raw.filter((t) => typeof t === "string");
    const typesOption = searchTypes.length ? searchTypes : ["establishment"];
    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        fields: ["geometry", "name", "formatted_address"],
        types: typesOption,
        componentRestrictions: { country: "us" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      // const place = autocomplete.getPlace();
      // if (place.geometry) {
      //   setSelectedPlace(place);
      //   setInputValue(place?.formatted_address);
      //   setZoom(7); 
      // }
    });

    setPlaceAutocomplete(autocomplete);
  }, [searchType, setSelectedPlace, setZoom, setPlaceAutocomplete]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value === "") {
      setSelectedPlace(null);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row justify-between mb-5 items-center gap-[20px]">
      <div className="flex sm:flex-row justify-start w-full lg:w-auto flex-col gap-5">
        <input
          className="map-input"
          type="text"
          ref={inputRef}
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Enter your Location"
        />
      </div>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: API_KEY,
  LoadingContainer: "div",
})(CustomMapControl);